import CancelIcon from '@mui/icons-material/Cancel';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DraggableProvided } from 'react-beautiful-dnd';
import { FlipCardItem } from '../../../models/LessonComponentContent';
import FlipItemEditor from './FlipItemEditor';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import React from 'react';
import { cloneDeep } from 'lodash';
import { styled } from '@mui/system';
import styles from '../../../styles/FlipCard.module.scss';

interface FlipItemEditorContainerProps {
  componentkey: number;
  flipCard: FlipCardItem;
  provided2?: DraggableProvided;
  length: boolean;
  onItemChange: (card: FlipCardItem) => void;
}

export const FlipItemEditorContainer = (
  props: FlipItemEditorContainerProps
) => {
  const { flipCard: currentFlipCard } = props;

  const handleFrontTextChange = (label: string) => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({ ...copy, frontLabel: label });
  };

  const handleBackTextChange = (label: string) => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({ ...copy, backLabel: label });
  };

  const handleFrontAssetSelect = (assetkey: string) => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({
      ...copy,
      frontImage: assetkey
    });
  };

  const handleBackAssetSelect = (assetkey: string) => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({
      ...copy,
      backImage: assetkey
    });
  };

  const handleRemoveFrontImage = () => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({
      ...copy,
      frontImage: ''
    });
  };

  const handleRemoveBackImage = () => {
    const copy = cloneDeep(currentFlipCard);
    props.onItemChange({
      ...copy,
      backImage: ''
    });
  };

  if (!currentFlipCard) {
    return <></>;
  }

  return (
    <>
      <Paper
        elevation={2}
        style={{ flex: 1 }}
        {...props.provided2?.dragHandleProps}
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            {...props.provided2?.dragHandleProps}
            style={{ width: '100%', flex: 1, color: 'rgba(0,0,0,0.54)' }}
          >
            {<DragIndicatorIcon />}
          </Grid>
          <Grid style={{ width: '100%', flex: 11 }}>
            <Grid container direction="column" className={styles.flipCardGrid}>
              <FlipItemEditor
                title="front"
                label={currentFlipCard.frontLabel || ''}
                componentkey={props.componentkey}
                assetkey={currentFlipCard?.frontImage}
                handleTextChange={handleFrontTextChange}
                handleAssetSelect={handleFrontAssetSelect}
                handleRemoveImage={handleRemoveFrontImage}
              />
              <Grid>
                <hr />
              </Grid>
              <FlipItemEditor
                title="back"
                label={currentFlipCard.backLabel || ''}
                componentkey={props.componentkey}
                assetkey={currentFlipCard?.backImage}
                handleTextChange={handleBackTextChange}
                handleAssetSelect={handleBackAssetSelect}
                handleRemoveImage={handleRemoveBackImage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
